import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {THUNK_STATUS} from '../../domain/types';
import {fetchTranscriptionUsage, UsageSnapshot} from './usageThunks';

interface UsageState {
  api: {
    status: THUNK_STATUS;
  };
  data: UsageSnapshot | null;
}

const initialState: UsageState = {
  api: {status: THUNK_STATUS.idle},
  data: null,
};

const usageSlice = createSlice({
  name: 'usage',
  initialState,
  reducers: {
    /**
     * A usage block that arrived on something other than `GET /rest/v1/usage`.
     *
     * The 402 and the session 429 from `/transcribe` both carry the balance the server just decided
     * the refusal with. Taking it here means the header agrees with the wall the user is looking at
     * immediately, instead of a round trip later — and it is the same numbers, not a guess.
     */
    usageReceived: (state, action: PayloadAction<UsageSnapshot>) => {
      state.api.status = THUNK_STATUS.fulfilled;
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTranscriptionUsage.pending, (state) => {
      state.api.status = THUNK_STATUS.pending;
    });
    builder.addCase(fetchTranscriptionUsage.fulfilled, (state, action) => {
      state.api.status = THUNK_STATUS.fulfilled;
      state.data = action.payload;
    });
    builder.addCase(fetchTranscriptionUsage.rejected, (state) => {
      state.api.status = THUNK_STATUS.rejected;
      // The previous snapshot is kept: a stale balance is more useful than none, and the pill
      // hides itself only when nothing has ever loaded.
    });
  },
});

export const {usageReceived} = usageSlice.actions;

export default usageSlice.reducer;
